import AsyncSelect from 'react-select/async';
import type { SingleValue } from 'react-select';
import { FormField } from '@/shared/ui/FormField';
import { filterSelectStyles } from '@/shared/ui/selectStyles';
import type { SelectOption } from '@/shared/ui/selectTypes';
import { searchCitiesAutocomplete } from './api';
import type { ProfileFormApi } from './ProfileInputs';

const REQUIRED = <span className="text-red">*</span>;

/** Legacy city autocomplete (site API) — no country/region cascade. */
export const CityAutocompleteField = ({ form }: { form: ProfileFormApi }) => {
  const { values, errors, patch } = form;
  const selected: SelectOption | null = values.cityId
    ? { value: values.cityId, label: values.cityName || `id ${values.cityId}` }
    : null;

  return (
    <FormField label={<>Город {REQUIRED}</>} errors={errors.city_id}>
      <AsyncSelect
        cacheOptions
        defaultOptions={selected ? [selected] : false}
        value={selected}
        loadOptions={searchCitiesAutocomplete}
        onChange={(next: SingleValue<SelectOption>) =>
          patch({ cityId: next?.value ?? '', cityName: next?.label ?? '' }, 'city_id')
        }
        placeholder="Начните вводить город..."
        loadingMessage={() => 'Поиск...'}
        noOptionsMessage={({ inputValue }) =>
          inputValue && inputValue.length > 2 ? 'Город не найден' : 'Введите минимум 3 символа'
        }
        isClearable
        styles={filterSelectStyles(400)}
        classNamePrefix="filter-select"
      />
    </FormField>
  );
};
